/**
 * ColorSetting Style03 - Stitch 設計：標題 + palette 圖示、Hue 漸層滑桿、5 預設色塊
 */
import { useState, useEffect } from 'react'
import type { TraitControlProps } from './types'
import './ColorSettingStyle03.css'

const PRESET_COLORS = [
  { hue: 0, bg: '#ef4444' },
  { hue: 220, bg: '#2563eb' },
  { hue: 150, bg: '#10b981' },
  { hue: 45, bg: '#f59e0b' },
  { hue: 270, bg: '#7c3aed' },
]

export function ColorSettingStyle03({
  state,
  onCommand,
  disabled = false,
}: TraitControlProps) {
  const hueFromState = (state?.spectrumHSV as { hue?: number })?.hue ?? (state?.hue as number)
  const currentHue = typeof hueFromState === 'number' ? Math.max(0, Math.min(360, Math.round(hueFromState))) : 180
  const [hue, setHue] = useState(currentHue)

  useEffect(() => {
    const v = typeof hueFromState === 'number' ? Math.max(0, Math.min(360, Math.round(hueFromState))) : 180
    setHue(v)
  }, [hueFromState])

  const handleSliderChange = (value: number) => {
    const safe = Math.max(0, Math.min(360, Math.round(value)))
    setHue(safe)
    void onCommand('setColor', { color: { spectrumHSV: { hue: safe, saturation: 1, value: 1 } } })
  }

  const handleSwatchClick = (h: number) => {
    if (disabled) return
    setHue(h)
    void onCommand('setColor', { color: { spectrumHSV: { hue: h, saturation: 1, value: 1 } } })
  }

  return (
    <div className="trait-colorsetting-style03 trait-stitch-glass">
      <div className="trait-colorsetting-style03__header">
        <span className="trait-colorsetting-style03__title">Color Setting</span>
        <span className="material-symbols-outlined trait-colorsetting-style03__icon">palette</span>
      </div>
      <div
        className="trait-colorsetting-style03__slider-wrap"
        style={{ '--thumb-hue': hue } as React.CSSProperties}
      >
        <input
          type="range"
          min={0}
          max={360}
          value={hue}
          onChange={(e) => setHue(Number(e.target.value))}
          onMouseUp={(e) => handleSliderChange(Number((e.target as HTMLInputElement).value))}
          onTouchEnd={(e) => handleSliderChange(Number((e.target as HTMLInputElement).value))}
          className="trait-colorsetting-style03__slider"
          disabled={disabled}
        />
      </div>
      <div className="trait-colorsetting-style03__swatches">
        {PRESET_COLORS.map(({ hue: h, bg }) => (
          <button
            key={h}
            type="button"
            className={`trait-colorsetting-style03__swatch ${Math.abs(hue - h) < 20 ? 'selected' : ''}`}
            style={{ backgroundColor: bg }}
            onClick={() => handleSwatchClick(h)}
            disabled={disabled}
          />
        ))}
      </div>
    </div>
  )
}
